<app-picture-card-grid>
  @for (image of visibleExistingImages(); track image.id) {
    <app-picture-card
      (click)="showDeleteImageActionSheet(image, true)"
      [canRemove]="true"
      [src]="getImageUrl(image)"
      />
  }

  @for (image of newImages; track image.id) {
    <app-picture-card
      (click)="showDeleteImageActionSheet(image, false)"
      [canRemove]="true"
      [src]="getImageUrl(image)"
      />
  }

  @if (!isAtMaxImages()) {
    <ion-card
      (click)="selectImagePicker()"
      class="ion-no-margin ion-no-padding picture-card"
      >
      <div class="position-absolute top-50 start-50 translate-middle">
        @if (isUploading()) {
          <ion-spinner color="primary" name="crescent" />
        } @else {
          <ion-icon color="primary" name="camera" size="large" slot="start" />
        }
      </div>
    </ion-card>
  }
</app-picture-card-grid>
